import React, { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { HiOutlineMenuAlt4 } from "react-icons/hi";
import {
  FaFacebook,
  FaTwitter,
  FaYoutube,
  FaPinterest,
  FaInstagram,
  FaUserCircle,
} from "react-icons/fa";
import { Link } from "react-scroll";
const Navbar = () => {
  const [nav, setNav] = useState(false);
  const [logo, setLogo] = useState(false);
  const [scroll, setScroll] = useState(false);
  const [mode, setMode] = useState(true);
  const [toggleBtn, setToggleBtn] = useState(
    '<i class="fas fa-moon"></i> Dark Mode'
  );
  const handleNav = () => {
    setNav(!nav);
    setLogo(!logo);
  };

  const navScroll = () => {
    setScroll(!scroll);
  };

  const toggleDarkMode = () => {
    if (mode) {
      document.documentElement.classList.add("dark");
      setToggleBtn('<i class="far fa-sun"></i>Light Mode');
      setMode((current) => (current = !current));
    }
    if (!mode) {
      document.documentElement.classList.remove("dark");
      setToggleBtn('<i class="fas fa-moon"></i> Dark Mode');
      setMode((current) => (current = !current));
    }
  };
  return (
    <div className="flex w-full justify-between items-center h-20 px-4 absolute z-10 dark:text-black text-white  drop-shadow-2xl dark:bg-gray-100 bg-gray-800">
      <div className="">
        <h1
          className={logo ? "hidden" : "block"}
          onClick={handleNav}
          onChange={navScroll}
        >
          HANGAR <span className="title">MOVIE</span>
        </h1>
      </div>
      <ul className="hidden md:flex">
        <li>
          <Link to="home" smooth={true} offset={-200} duration={500}>
            HOME
          </Link>
        </li>
        <li>
          <Link to="movies" smooth={true} duration={500}>
            MOVIES
          </Link>
        </li>
      </ul>

      <div className="hidden md:flex cursor-pointer">
        <div className="ml-auto font-medium dark:text-black justify-between items-center text-white focus:outline-none">
          <button
            className="focus:border-none "
            onClick={() => toggleDarkMode()}
            dangerouslySetInnerHTML={{ __html: toggleBtn }}
          ></button>
        </div>
        <div className="flex justify-center items-center mx-2">
          <FaUserCircle size={25} />
        </div>
      </div>

      {/* Hamburger */}
      <div className="md:hidden cursor-pointer z-10" onClick={handleNav}>
        {nav ? (
          <AiOutlineClose size={20} className="text-black" />
        ) : (
          <HiOutlineMenuAlt4 className="" size={20} />
        )}
      </div>

      {/* Mobile menu dropdown */}
      <div
        className={
          nav
            ? "absolute text-black left-0 top-0 w-full bg-gray-300/90 px-4 py-7 flex flex-col"
            : "absolute left-[-100%]"
        }
        onClick={handleNav}
      >
        <ul>
          <h1>HANGAR MOVIE</h1>
          <li>
            <Link to="movies" smooth={true} duration={500}>
              MOVIES
            </Link>
          </li>
          <li>
            <Link to="trailer" smooth={true} offset={-200} duration={500}>
              TRAILERS
            </Link>
          </li>
          <li>
            <Link to="cast" smooth={true} offset={-50} duration={500}>
              CAST
            </Link>
          </li>
          <div className="flex flex-col ">
            <button className="my-6 bg-gradient-to-r from-[var(--primary-dark)] to-[var(--primary-light)] rounded-full">
              Login
            </button>
            <button className="bg-gradient-to-r from-[var(--primary-dark)] to-[var(--primary-light)] rounded-full">
              Register
            </button>
          </div>
          <div className="flex justify-between my-6">
            <FaFacebook className="icon" />
            <FaTwitter className="icon" />
            <FaInstagram className="icon" />
            <FaPinterest className="icon" />
            <FaYoutube className="icon" />
          </div>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
